// @ts-nocheck
import ReactStars from "react-rating-stars-component";

const StarRatings = ({ rating, size }) => {
  return <ReactStars activeColor="#FFC107" size={size} count={5} isHalf={true} value={rating} edit={false} />;
};

export default StarRatings;
